import { mapMutations } from 'vuex'

import get from 'lodash/get'
import includes from 'lodash/includes'
import head from 'lodash/head'
import has from 'lodash/has'

export default {
  name: 'node-link',
  props: {
    title: {
      type: String,
    },
    type: {
      type: String,
    },
    nid: {
      type: [String, Number],
    },
    url: {
      type: String,
    },
    destinationTid: {
      type: [String, Number, Boolean],
    },
  },
  methods: {
    ...mapMutations([
      'setArticleListTid',
    ]),
  },
  render (h) {
    const router = this.$router
    const data = {attrs: { href: this.url }}
    const routeData = {
      type: this.type,
      nid: this.nid,
      url: this.url,
      title: this.title,
      // This is a dummy props, where we should get node object from vuex
      props: {
        nid: this.nid,
        destinationTid: this.destinationTid,
      },
    }

    router.addRouteByNode({routeData})
    // Router push to the route when it is clicked.
    data.on = {click: (e) => {
      e.preventDefault()
      if (this.destinationTid) {
        this.$store.commit('setArticleListTid', this.destinationTid)

        const route = get(this, '$route', {})
        const components = get(head(get(route, 'matched', [])), 'components.default.components', false)
        const isArticleToArticle = has(components, 'ArticleView')

        // So links will go to the routed article, ArticleView.vue needs to be refreshed to the routed article.
        if (isArticleToArticle) {
          this.$store.dispatch('toggleRouteTransition', true)
          this.$store.commit('setIsRefreshedToRoutedArticle', true)

          if (includes(window.location.href, routeData.url)) {
            this.$store.dispatch('toggleRouteTransition', false)
            this.$store.commit('setIsRefreshedToRoutedArticle', false)
          }
        }
      }
      router.push(routeData.url)
    }}
    return h('a', data, this.$slots.default)
  },
}



// WEBPACK FOOTER //
// ./components/node/Link.js